/**
 * Programme detail component
 */
import 'rxjs/add/operator/switchMap';

import { ChangeDetectorRef, Component, ComponentRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { AppComponent } from '../app.component';
import { ProfileService } from '../services/profile.service';
import { VoxPopService } from '../services/voxpop.service';
import { Programme } from '../types/programme';


@Component({
  moduleId: module.id,
  selector: 'programme-detail',
  templateUrl: './programme-detail.component.html',
  styleUrls: ['./programme-detail.component.css'],
  providers: [VoxPopService],
})

export class ProgrammeDetailComponent implements OnInit {
  @ViewChild("short_name") short_name: ComponentRef<HTMLInputElement>;
  programme: Programme;
  errorMessage: string;
  editable: boolean = false;
  @Input() inserting: any = false;
  @Output() cancelled: EventEmitter<any> = new EventEmitter();

  constructor(
    private voxPopService: VoxPopService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    if (!ProfileService.IsLoggedIn()) return;

    if (this.inserting) {
      this.programme = new Programme();
      this.editable = true;
    } else {
      console.log("Getting programme detail.");
      this.route.params
        .switchMap((params: Params) => this.voxPopService.getProgramme(+params['programmeid']))
        .subscribe(
          programme => this.setProgramme(programme),
          error => this.errorMessage = <any>error,
        );


      AppComponent.SetTitle("Programme " + this.route.params['programmeid'])
    }
  }

  forceValidShortName(f: string, g: string): boolean {
    // console.log(g + " f: " + f + " current: " + this.programme.short_name);
    let newValue = f.toLowerCase();
    newValue = newValue.replace(/[^a-z0-9_-]/g, '');
    if (newValue === this.programme.short_name) {
      // console.log(g + " f: " + f + "  --  forcing change detection... " + newValue);
      this.programme.short_name = newValue;
      // this.short_name.changeDetectorRef.markForCheck();
      this.cdr.detectChanges();
      return false;
    }
    // console.log(g + " now: " + newValue + " current: " + this.programme.short_name);
    this.programme.short_name = newValue;
    // this.cdr.detectChanges();
    // try {
    //   console.log(this.short_name);
    // } catch (e) {
    //   console.log(e);
    // }
    let sn: HTMLInputElement = <HTMLInputElement>document.getElementById('short_name');
    sn.value = newValue;
    return true;
  }

  setProgramme(programme: Programme) {
    console.log("Loaded programme " + programme.name + "(" + programme.id + ")");
    this.programme = programme;
    AppComponent.SetTitle(programme.name + ' (' + programme.id + ')')
  }

  CanAdminister(): boolean {
    if (this.programme.id < 1) {
      return ProfileService.CanAdminister();
    }
    return ProfileService.CanAdministerProgramme(this.programme.id);
  }

  GlobalAdmin(): boolean {
    return ProfileService.CanAdministerAll();
  }

  cancel(): void {
    this.editable = false;
    this.cancelled.emit(null)
  }

  save(): void {
    if (<any>this.programme.active == "true") this.programme.active = true;
    if (<any>this.programme.active == "false") this.programme.active = false;
    if (this.inserting) {
      console.log("Saving programme: " + this.programme.name + "(" + this.programme.id + ")");
      this.voxPopService.createProgramme(this.programme)
        .subscribe(
          programme => {
            this.setProgramme(programme);
            this.editable = false;
            this.inserting = false
          },
          error => this.errorMessage = <any>error,
        );
    } else {
      this.voxPopService.updateProgramme(this.programme)
        .subscribe(() => this.editable = false);
    }
  }

  edit(): void {
    this.editable = true;
  }
}
